module.exports = __webpack_public_path__ + "media/images/logo-oscuro-cuota-facil-svg-f59903de6498ec9de97c2a699f7376fd.svg";